// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"135":"0c0d092a10b04429","354":"4e00006316b76e93","2537":"575f0e80f313c214","4368":"4f34b61beea3f3ce","8095":"c311bb8ae5e11555"}[chunkId] + ".css";
};